import React, { Fragment, memo } from 'react';

import LabelWithAsterisks from 'app/shared/components/common/LabelWithAsterisks';
import clsx from 'clsx';
import PropTypes from 'prop-types';

const defaultArray = [];
const defaultObject = {};

const ProgramTooltipDetails = ({
  data = defaultArray,
  format: { nameFormat, valueFormat } = defaultObject,
}) => (
  <div className="min-w-[224px]">
    {data.map(({ name, value, meta, groupId, isNewGroup }, index) => {
      const formattedName = nameFormat ? nameFormat(name) : name;
      const formattedValue = valueFormat ? valueFormat(value) : value;

      return (
        <Fragment key={index}>
          {isNewGroup && <br />}
          <div className={clsx(meta?.rowClassName, 'flex items-end justify-between gap-12')}>
            <LabelWithAsterisks asterisksQuantity={groupId}>{formattedName}</LabelWithAsterisks>
            <div className="whitespace-nowrap text-right">{formattedValue}</div>
          </div>
        </Fragment>
      );
    })}
  </div>
);

ProgramTooltipDetails.propTypes = {
  data: PropTypes.array,
  format: PropTypes.object,
};

export default memo(ProgramTooltipDetails);
